import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointsConnectorsCell } from './charge-points-connectors.cell';
import { ChargePointsConnectorsHeader } from './charge-points-connectors.header';

export const ChargePointsConnectorsColumn: IdentifiedColumnDef<
  GatewayChargePointInMaintenanceModel,
  GatewayChargePointInMaintenanceModel['channels']
> = {
  id: 'connectors',
  enableSorting: false,
  header: ChargePointsConnectorsHeader,
  cell: ChargePointsConnectorsCell,
};
